import { collection, addDoc, query, where, orderBy, getDocs, updateDoc, doc } from 'firebase/firestore'
import { db } from './config'

// Create a new notification
export const createNotification = async (notificationData) => {
    try {
        const docRef = await addDoc(collection(db, "notifications"), {
            ...notificationData,
            createdAt: new Date(),
            isRead: false
        })
        console.log("Notification created with ID:", docRef.id)
        return docRef.id
    } catch (error) {
        console.error("Error creating notification:", error)
        throw error
    }
}

// Get notifications for a specific admin user
export const getAdminNotifications = async (adminUserId) => {
    try {
        const q = query(
            collection(db, "notifications"),
            where("adminUserId", "==", adminUserId),
            orderBy("createdAt", "desc")
        )
        const querySnapshot = await getDocs(q)
        const notifications = []
        querySnapshot.forEach((doc) => {
            notifications.push({
                id: doc.id,
                ...doc.data()
            })
        })
        return notifications
    } catch (error) {
        console.error("Error getting admin notifications:", error)
        throw error
    }
}

// Mark notification as read
export const markNotificationAsRead = async (notificationId) => {
    try {
        const notificationRef = doc(db, "notifications", notificationId)
        await updateDoc(notificationRef, {
            isRead: true
        })
        console.log("Notification marked as read:", notificationId)
    } catch (error) {
        console.error("Error marking notification as read:", error)
        throw error
    }
}

// Mark all notifications as read for an admin user
export const markAllNotificationsAsRead = async (adminUserId) => {
    try {
        const q = query(
            collection(db, "notifications"),
            where("adminUserId", "==", adminUserId),
            where("isRead", "==", false)
        )
        const querySnapshot = await getDocs(q)
        
        const updatePromises = querySnapshot.docs.map(doc => 
            updateDoc(doc.ref, { isRead: true })
        )
        
        await Promise.all(updatePromises)
        console.log("All notifications marked as read for admin:", adminUserId)
    } catch (error) {
        console.error("Error marking all notifications as read:", error)
        throw error
    }
}

// Get unread notification count for an admin user
export const getUnreadNotificationCount = async (adminUserId) => {
    try {
        const q = query(
            collection(db, "notifications"),
            where("adminUserId", "==", adminUserId),
            where("isRead", "==", false)
        )
        const querySnapshot = await getDocs(q)
        return querySnapshot.size
    } catch (error) {
        console.error("Error getting unread notification count:", error)
        throw error
    }
} 